import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAnalyticsConsent, loadAnalytics, trackPageView } from "../lib/analytics";

export function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (getAnalyticsConsent() !== "granted") return;
    loadAnalytics()
      .then(() => trackPageView(`${location.pathname}${location.search}`))
      .catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
